import { render, staticRenderFns } from "./DeviceBeaconPage.vue?vue&type=template&id=63b78b68&scoped=true&"
import script from "./DeviceBeaconPage.vue?vue&type=script&lang=js&"
export * from "./DeviceBeaconPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b78b68",
  null
  
)

export default component.exports